/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react'
import Swal from 'sweetalert2'
import { Modal, Button } from 'react-bootstrap'
import { postRequestOptions, getRequestOptions } from '../helpers/Fetchwrapper'
import validationErrorMsg from '../helpers/ValidationErrorMsg'
import Spinner from 'react-bootstrap/Spinner'
import { Table } from 'react-bootstrap-v5';
import Select from 'react-select'


interface EditSalesOrderFreeItemProps {
	show: boolean;
	handleClose: any;
	salesOrderInfo: any;
}

const EditSalesOrderFreeItem: React.FC<EditSalesOrderFreeItemProps> = ({ show, handleClose, salesOrderInfo }) => {

	const [freeRows, setFreeRows] = useState<any[]>([]);
	const [isSubmitDisable, setSubmitDisable] = useState(false);
	const [loading, setLoading] = useState(false);
	const [products, setProducts] = useState<any[]>([]);

	useEffect(() => {
		if (show && salesOrderInfo) {
			const projectId = salesOrderInfo.id_projects || salesOrderInfo.idProjects;
			if (projectId) {
				getProducts(projectId);
			}
			const existingRows = salesOrderInfo.freeRows || [];
			const freshRows = existingRows.map((dataRow: any) => {
				const productId = dataRow.id_products || dataRow.idProducts;
				const alternateNameId = dataRow.id_product_group_alternate_names !== null && dataRow.id_product_group_alternate_names !== undefined
					? dataRow.id_product_group_alternate_names
					: (dataRow.idProductGroupAlternateNames !== null && dataRow.idProductGroupAlternateNames !== undefined
						? dataRow.idProductGroupAlternateNames
						: null);

				return {
					...dataRow,
					id_products: productId,
					id_product_group_alternate_names: alternateNameId,
					id_sales_order_free_rows: dataRow.id_sales_order_free_rows || dataRow.idSalesOrderFreeRows,
					quantity: parseFloat(dataRow.quantity || 0),
					productName: (alternateNameId !== null && dataRow.alternate_name)
						? dataRow.alternate_name.alternate_name
						: (dataRow.product ? dataRow.product.product_name : ''),
				};
			});
			setFreeRows(freshRows);
		} else if (!show) {
			setFreeRows([]);
			setProducts([]);
		}
	}, [show, salesOrderInfo]);

	const getProducts = (projectId: number) => {
		fetch(
			process.env.REACT_APP_API_URL + 'products?idProjects=' + projectId,
			getRequestOptions()
		)
			.then((resp) => resp.json())
			.then((resp) => {
				let productsList = resp.data.map((item: any) => {
					item.label = item.name_value + ' (' + item.packing + ' ' + item.item_unit_name + ')';
					const alternateNameId = item.id_product_group_alternate_names === null || item.id_product_group_alternate_names === undefined
						? 'null'
						: String(item.id_product_group_alternate_names);
					item.value = String(item.id_products) + '-' + alternateNameId;
					return item;
				});
				setProducts(productsList);
			})
			.catch((error) => {
				console.log(error, 'catch the hoop');
			});
	};

	const handleProductChange = (selectedOption: any, index: number) => {
		const updatedRows = [...freeRows];
		updatedRows[index].id_products = parseInt(selectedOption.value.split('-')[0]);
		updatedRows[index].id_product_group_alternate_names = selectedOption.value.split('-')[1] === "null" ? null : parseInt(selectedOption.value.split('-')[1]);
		updatedRows[index].productName = selectedOption.label;
		setFreeRows(updatedRows);
	};

	const getSelectedProductValue = (row: any) => {
		const productId = row.id_products || row.idProducts;
		const alternateNameId = row.id_product_group_alternate_names !== null && row.id_product_group_alternate_names !== undefined
			? row.id_product_group_alternate_names
			: (row.idProductGroupAlternateNames !== null && row.idProductGroupAlternateNames !== undefined
				? row.idProductGroupAlternateNames
				: null);

		if (productId) {
			const alternateNameStr = alternateNameId === null || alternateNameId === undefined ? 'null' : String(alternateNameId);
			return String(productId) + '-' + alternateNameStr;
		}
		return null;
	};

	const getSelectedProduct = (row: any) => {
		if (!products.length) return null;
		const productId = row.id_products || row.idProducts;
		if (!productId) return null; // New row without product selection
		const value = getSelectedProductValue(row);
		if (!value) return null;
		const found = products.find(p => String(p.value) === String(value));
		if (!found) {
			const foundById = products.find(p => String(p.value).split('-')[0] === String(productId));
			return foundById || null;
		}
		return found;
	};

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
		const updatedRows = [...freeRows];
		updatedRows[index][e.target.name] = (e.target.type === 'number') ? parseFloat(e.target.value) : e.target.value;
		setFreeRows(updatedRows);
	};

	const handleAddFreeItem = () => {
		setFreeRows([...freeRows, {
			id_sales_order_free_rows: null,
			id_products: null,
			id_product_group_alternate_names: null,
			quantity: 1,
			productName: '',
		}]);
	};

	const salesOrderFreeItemSave = async (event: any) => {
		setLoading(true);
		event.preventDefault();
		setSubmitDisable(true);
		const confirm = await Swal.fire({
			title: 'Are you sure?',
			text: "You want to update the Free Items!",
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#ec008c',
			cancelButtonText: 'Cancel',
			confirmButtonText: 'Yes, Submit it!',
		});
		if (confirm.value) {
			const rowsToSave = freeRows.filter((row: any) => {
				const productId = row.id_products || row.idProducts;
				const qty = parseFloat(row.quantity || 0);
				return productId && qty >= 1;
			});
			if (rowsToSave.length === 0) {
				Swal.fire({
					icon: 'error',
					title: 'Error',
					text: 'Please add at least one free item with product and quantity.',
				});
				setSubmitDisable(false);
				setLoading(false);
				return;
			}
			const requestOptions = postRequestOptions({
				freeRows: rowsToSave,
				idSalesOrders: salesOrderInfo.id_sales_orders
			});
			try {
				let response = await fetch(
					`${process.env.REACT_APP_API_URL}sales-order/update-order-free-items`,
					requestOptions
				);
				let respData = await response.json();
				if (respData.success === true) {
					const successMsg = respData.successMessage;
					Swal.fire({
						icon: 'success',
						title: 'Success',
						text: successMsg,
					});
					handleClose(true);
				} else {
					const errorsMessage = validationErrorMsg(respData.errors).join('<br>');
					Swal.fire({
						icon: 'error',
						title: 'Error',
						html: errorsMessage,
					});
				}
			} catch (error) {
				console.log(error, 'catch the hoop');
			}
			setSubmitDisable(false);
			setLoading(false);
		} else {
			setSubmitDisable(false);
			setLoading(false);
		}
	};

	return (
		<Modal
			show={show}
			onHide={() => handleClose(false)}
			size="xl"
			dialogClassName="modal-xl-custom"
		>
			<style>{`
				.modal-xl-custom {
					max-width: 95vw !important;
					width: 95vw !important;
				}
			`}</style>
			<form onSubmit={salesOrderFreeItemSave}>
				<Modal.Header closeButton>
					<h3>Edit Free Items</h3>
				</Modal.Header>
				<Modal.Body>
					<div className="form-group row">
						<div className="mb-2">
							<button type="button" className="btn btn-light-primary btn-sm" onClick={handleAddFreeItem}>
								+ Add Free Item
							</button>
						</div>
						<Table striped bordered hover size="sm">
							<thead>
								<tr>
									<th>Product</th>
									<th>Quantity</th>
								</tr>
							</thead>
							<tbody>
								{freeRows?.map((item, index) => (
									<tr key={'freeitem' + index}>
										<td width="70%">
											<Select
												key={`product-select-${index}-${products.length}-${item.id_products || item.idProducts}`}
												value={getSelectedProduct(item)}
												onChange={(selectedOption) => handleProductChange(selectedOption, index)}
												options={products}
												className='sm'
												menuPosition="fixed"
												placeholder={item.productName || 'Select product'}
												isClearable={false}
												styles={{
													control: (provided) => ({
														...provided,
														height: '32px',
														minHeight: '32px',
													}),
													container: (provided) => ({
														...provided,
														height: '32px',
													}),
												}}
											/>
										</td>
										<td>
											<input
												type="number"
												name="quantity"
												value={item.quantity}
												onChange={(e) => handleChange(e, index)}
												className="form-control form-control-sm"
												min={1}
												step="any"
											/>
										</td>
									</tr>
								))}
							</tbody>
						</Table>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<button type="submit" disabled={isSubmitDisable || loading} className="btn btn-sm btn-primary me-2">
						{loading && (
							<Spinner
								as="span"
								animation="grow"
								size="sm"
								role="status"
								aria-hidden="true"
							/>
						)}
						<span>  Update</span>
					</button>
					<Button variant='secondary' size="sm" onClick={() => handleClose(false)}>
						Close
					</Button>
				</Modal.Footer>
			</form>
		</Modal>
	);
};

export default EditSalesOrderFreeItem;
